var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C6C6C6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "briefcase-solid",
    className: "st0",
    d: "M38.29,18.78H61.7c0.72,0,1.3,0.58,1.3,1.3v6.5H36.99v-6.5 C36.99,19.37,37.57,18.78,38.29,18.78L38.29,18.78z M29.19,20.08v6.5H18.78C13.03,26.59,8.37,31.25,8.37,37v15.61h83.25V37 c0-5.75-4.66-10.4-10.41-10.41h-10.4v-6.5c0-5.03-4.08-9.11-9.1-9.11H38.3C33.26,10.99,29.19,15.06,29.19,20.08L29.19,20.08z  M91.62,57.81H60.4v5.2c0,2.87-2.33,5.2-5.2,5.2l0,0H44.79c-2.87,0-5.2-2.33-5.2-5.2l0,0v-5.2H8.37v20.81 c0.01,5.74,4.66,10.4,10.41,10.41h62.44c5.74-0.01,10.4-4.66,10.41-10.41V57.81H91.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.a99e9a4963767404d85d0ac1faa7a558.svg";
export { ForwardRef as ReactComponent };